import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { environment } from '@environments/environment';
import { Store } from '@ngrx/store';
import { mobileNavigationMenuAnimations } from '@platform/dashboard/components/mobile-navigation-menu/mobile-navigation-menu-animations';
import { IconComponent } from '@shared-lib/components/icon/icon.component';
import { HasCompanyClientUiSettingsEnabledDirective } from '@shared/directives/has-company-client-ui-settings-enabled.directive';
import { CompanyClientUISettingsKey } from '@shared/services/company-client-ui-settings.service';
import { selectIsExperianCompany } from '@shared/store/common.selectors';
import { paths } from '../../../paths';

@Component({
  selector: 'cp-mobile-navigation-menu',
  imports: [IconComponent, RouterLink, RouterLinkActive, HasCompanyClientUiSettingsEnabledDirective, AsyncPipe],
  templateUrl: './mobile-navigation-menu.component.html',
  styleUrls: ['./mobile-navigation-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: mobileNavigationMenuAnimations,
})
export class MobileNavigationMenuComponent {
  protected readonly globalStore = inject(Store);

  protected readonly paths = paths;
  protected readonly isMobileApp = environment.mobileApp?.isMobileApp;
  protected readonly showDocumentUploadKey: CompanyClientUISettingsKey = 'showDocument';

  protected readonly isExperianCompany$ = this.globalStore.select(selectIsExperianCompany);
}
